import * as React from "react"
import { IconWithCircleProps } from "./IconWithCircleProps"

export const Star = (props: IconWithCircleProps) => {
  const { color = "currentColor", circleColor } = props

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill={circleColor} />
      <path
        d="M9.62 6.66651L8.64 3.43984C8.44666 2.80651 7.55333 2.80651 7.36666 3.43984L6.38 6.66651H3.41333C2.76666 6.66651 2.5 7.49984 3.02666 7.87318L5.45333 9.60651L4.5 12.6798C4.30666 13.2998 5.02666 13.7998 5.54 13.4065L8 11.5398L10.46 13.4132C10.9733 13.8065 11.6933 13.3065 11.5 12.6865L10.5467 9.61318L12.9733 7.87984C13.5 7.49984 13.2333 6.67318 12.5867 6.67318H9.62V6.66651Z"
        fill={color}
      />
    </svg>
  )
}
